import { IconButton } from '@creditornot/cb-button';
import { Download, Trashbin } from '@creditornot/cb-icons';
import React from 'react';
import styled from 'styled-components';

import { downloadFromUrl } from 'common/utils/download';

import DraggableImage from './DraggableImage';

type Props = {
  className?: string;
  imageId: string;
  imageUrl: string;
  interactionsDisabled: boolean;
  downloadUrl?: string;
  onRemove?: (imageId: string) => void;
};

const Actions = styled.div`
  display: flex;
  align-items: center;
`;

const ExistingImage = ({ imageId, imageUrl, interactionsDisabled, downloadUrl, onRemove }: Props) => {
  return (
    <DraggableImage
      draggingDisabled={interactionsDisabled}
      imageId={imageId}
      imageUrl={imageUrl}
      rightContent={
        <Actions>
          {downloadUrl && (
            <IconButton
              disabled={interactionsDisabled}
              variant="brand"
              size="tiny"
              style={{ marginInlineEnd: '8px' }}
              onClick={() => downloadFromUrl(downloadUrl)}
            >
              <Download />
            </IconButton>
          )}
          <IconButton
            disabled={interactionsDisabled || !onRemove}
            size="tiny"
            onClick={() => onRemove && onRemove(imageId)}
            variant="negative"
          >
            <Trashbin />
          </IconButton>
        </Actions>
      }
    />
  );
};

export default React.memo(ExistingImage);
